module.exports = __webpack_public_path__ + "img/wechat.f3ce3b43.png";